// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var EmailRegexJs = require("./emailRegex.js").default;

var emailRegex = EmailRegexJs;

function isEmail(email) {
  if (emailRegex.test(email)) {
    return true;
  } else {
    return false;
  }
}

exports.emailRegex = emailRegex;
exports.isEmail = isEmail;
/* emailRegex Not a pure module */
